/**
 * Een wijziging die de server al heeft vastgelegd (bijv. de afwijkende dag na "Mila is ziek") hoort
 * in het concept én in de opgeslagen stand. Alleen in het concept zou ze als "niet opgeslagen"
 * tellen, en "Verwerpen" zou haar weghalen terwijl ze op de server staat; de volgende "Opslaan"
 * zou haar daarna ook daar wissen. Andere, nog niet opgeslagen wijzigingen blijven gewoon staan.
 * Puur, zonder React (AdminContext gebruikt dit).
 */
export function confirmInto<T>(draft: T, savedJson: string, fn: (value: T) => T): { draft: T; saved: string } {
  return { draft: fn(draft), saved: JSON.stringify(fn(JSON.parse(savedJson) as T)) }
}

/**
 * De nieuwe versie van het beheerblok overnemen, maar alleen als de server precies één stap verder
 * is dan wij: dan was dit de enige wijziging. Was iemand anders intussen ook bezig (ander tabblad,
 * telefoon), dan blijft onze versie staan en geeft de volgende "Opslaan" eerlijk 409.
 */
export const adoptRevision = (current: number, returned: number | undefined): number =>
  returned !== undefined && returned === current + 1 ? returned : current
